import { SessionExpiredMessage } from "@tableyeti/webview-messages/src/events/basecamp";
import {
  NativeAppEvents,
  NativeAppMessage,
} from "@tableyeti/webview-messages/src/events/native-app";
import { CognitoUser, CognitoUserSession } from "amazon-cognito-identity-js";
import { useAuthenticationStore, userPool } from "@/store/authentication";
import { sendWebviewMessage } from "@/utils/native-app-webview";

export default {
  install() {
    const authenticationStore = useAuthenticationStore();
    const handleNativeAppMessage = (message: string) => {
      const { event, data } = JSON.parse(message) as NativeAppMessage;
      if (event === NativeAppEvents.TokensRefreshed) {
        const { idToken, accessToken } = data;
        authenticationStore.refreshCompanionSession(idToken, accessToken);
      }
    };

    window.addEventListener("message", (message) => handleNativeAppMessage(message.data));

    const requestTokenRefresh = () => {
      sendWebviewMessage(SessionExpiredMessage);
    };

    const checkTokenExpiration = async () => {
      if (!authenticationStore.user.isAuthenticated) {
        return;
      }

      const user = userPool.getCurrentUser() as CognitoUser;
      if (user) {
        user.getSession((error: Error | null, session: CognitoUserSession) => {
          if (error || isTokenExpired(session)) {
            requestTokenRefresh();
          }
        });
      }
    };

    setInterval(checkTokenExpiration, 60000);
    checkTokenExpiration();
  },
};

const isTokenExpired = (session: CognitoUserSession) => {
  const expirationTime = session.getIdToken().getExpiration() * 1000;
  const currentTime = Date.now();
  const timeUntilExpiry = expirationTime - currentTime;
  const fiveMinutesInMs = 5 * 60 * 1000;
  return timeUntilExpiry < fiveMinutesInMs;
};
